import { Controller } from '@hotwired/stimulus'

// Keeps promo expiry picker after the chosen start time (same pattern as flash sales).
export default class extends Controller {
  static targets = ['expiresPicker', 'startsInput']

  connect () {
    this.syncExpiresMinDate()
    // Nested datetime-picker may connect a tick later.
    this.syncTimer = window.setTimeout(() => this.syncExpiresMinDate(), 50)
  }

  disconnect () {
    if (this.syncTimer) window.clearTimeout(this.syncTimer)
  }

  syncExpiresMinDate () {
    const picker = this.expiresPickerController()
    if (!picker?.setMinDate) return

    picker.setMinDate(this.earliestExpiryDate())
  }

  expiresPickerController () {
    if (!this.hasExpiresPickerTarget) return null

    return this.application.getControllerForElementAndIdentifier(
      this.expiresPickerTarget,
      'datetime-picker'
    )
  }

  earliestExpiryDate () {
    const startsAt = this.parsePickerDate(this.startsAtValue())
    if (startsAt) {
      // Expiry must be strictly after start (flatpickr minute step is 5).
      return new Date(startsAt.getTime() + 5 * 60 * 1000)
    }

    // No start yet — still block past times.
    return new Date(Date.now() + 5 * 60 * 1000)
  }

  startsAtValue () {
    if (this.hasStartsInputTarget) return this.startsInputTarget.value

    return this.element.querySelector('#coupon_starts_at')?.value
  }

  parsePickerDate (value) {
    const match = String(value || '')
      .trim()
      .match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?/)
    if (!match) return null

    const date = new Date(
      Number(match[1]),
      Number(match[2]) - 1,
      Number(match[3]),
      Number(match[4] || 0),
      Number(match[5] || 0),
      0,
      0
    )
    return Number.isNaN(date.getTime()) ? null : date
  }
}
